import type { AdminAccessResponse } from '@/core/generated/api';
import { canAccessPermission } from '@/shared/model/adminAccess';
import type { ActionMenuItem } from './types';

/** Возвращает доступные действия и разделители групп */
export const filterAvailableActions = (
    items: readonly ActionMenuItem[],
    snapshot: AdminAccessResponse | null,
): ActionMenuItem[] => {
    const available = items.filter((item) => item.visible !== false
        && (!item.permission || canAccessPermission(snapshot, item.permission)));

    const result: ActionMenuItem[] = [];

    for (const item of available) {
        if (item.separator && (!result.length || result[result.length - 1]?.separator)) continue;
        result.push(item);
    }

    if (result[result.length - 1]?.separator) result.pop();

    return result;
};
